export function formatDateKey(date: Date): string {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function parseDateKey(value: string): Date {
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year, month - 1, day);
}

export function formatDisplayDate(value: string, options?: Intl.DateTimeFormatOptions): string {
  return parseDateKey(value).toLocaleDateString('en-US', options ?? {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}

export function isToday(value: string | null): boolean {
  return value === formatDateKey(new Date());
}

export function isOverdue(value: string | null): boolean {
  if (!value) {
    return false;
  }

  return value < formatDateKey(new Date());
}

export function toDateTimeInputValue(value: string | null): string {
  if (!value) {
    return '';
  }

  const date = new Date(value);
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  const hours = `${date.getHours()}`.padStart(2, '0');
  const minutes = `${date.getMinutes()}`.padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

export function fromDateTimeInputValue(value: string): string | null {
  if (!value) {
    return null;
  }

  return new Date(value).toISOString();
}

export function addDays(dateKey: string, days: number): string {
  const date = parseDateKey(dateKey);
  date.setDate(date.getDate() + days);
  return formatDateKey(date);
}

export function startOfWeek(date: Date): Date {
  const copy = new Date(date);
  const offset = (copy.getDay() + 6) % 7;
  copy.setDate(copy.getDate() - offset);
  copy.setHours(0, 0, 0, 0);
  return copy;
}

export function endOfWeek(date: Date): Date {
  const copy = startOfWeek(date);
  copy.setDate(copy.getDate() + 6);
  copy.setHours(23, 59, 59, 999);
  return copy;
}

export function describeDate(value: string | null): string {
  if (!value) {
    return 'No due date';
  }

  if (isToday(value)) {
    return 'Due today';
  }

  if (isOverdue(value)) {
    return 'Overdue';
  }

  return formatDisplayDate(value, { month: 'short', day: 'numeric' });
}

export function formatTimeLabel(value: string | null): string {
  if (!value) {
    return '';
  }

  return value;
}
